/* NoliX theme — small progressive enhancements (no dependencies) */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    main.srcset = '';
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  // Variant selection -> update hidden id, price and button state
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var selects = form.querySelectorAll('[data-option]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var button = form.querySelector('[data-add]');
    var buyBtn = form.querySelector('[data-buy]');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) { button.disabled = true; button.textContent = button.getAttribute('data-unavailable'); if (buyBtn) buyBtn.disabled = true; return; }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      button.disabled = !match.available;
      if (buyBtn) buyBtn.disabled = !match.available;
      button.textContent = match.available ? button.getAttribute('data-add-label') : button.getAttribute('data-soldout');
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  // Trademark status filter
  document.querySelectorAll('[data-tm-filter]').forEach(function (bar) {
    var scope = bar.closest('section') || document;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var f = b.getAttribute('data-filter');
      bar.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      scope.querySelectorAll('[data-status]').forEach(function (card) {
        card.hidden = !(f === 'all' || card.getAttribute('data-status') === f);
      });
    });
  });
})();

// Product video popups (Industries page)
document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-video-open]');
  if (open) {
    var dlg = document.getElementById(open.getAttribute('data-video-open'));
    if (!dlg) return;
    var frame = dlg.querySelector('iframe[data-src]');
    if (frame) frame.src = frame.getAttribute('data-src');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var v = dlg.querySelector('video'); if (v) { try { v.play(); } catch (err) {} }
    return;
  }
  var dlgEl = e.target.closest('dialog.video-modal');
  if (e.target.closest('[data-video-close]') || (dlgEl && e.target === dlgEl)) { dlgEl.close ? dlgEl.close() : dlgEl.removeAttribute('open'); }
});
document.querySelectorAll('dialog.video-modal').forEach(function (dlg) {
  dlg.addEventListener('close', function () {
    var v = dlg.querySelector('video'); if (v) v.pause();
    var f = dlg.querySelector('iframe'); if (f) f.removeAttribute('src');
  });
});

// Video gallery filter
document.querySelectorAll('[data-video-filter]').forEach(function (bar) {
  var grid = bar.parentElement.querySelector('.video-grid');
  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-filter]');
    if (!btn) return;
    bar.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    var f = btn.getAttribute('data-filter');
    grid.querySelectorAll('.video-card').forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-cat') !== f; });
  });
});

// Leak cost calculator
document.querySelectorAll('[data-calc]').forEach(function (el) {
  var gpd = parseFloat(el.getAttribute('data-gpd')) || 200;
  var price = parseFloat(el.getAttribute('data-price')) || 69.99;
  var nIn = el.querySelector('[data-in="n"]'), rIn = el.querySelector('[data-in="rate"]');
  function out(k, v) { var o = el.querySelector('[data-out="' + k + '"]'); if (o) o.textContent = v; }
  function fmt(v) { return Math.round(v).toLocaleString('en-US'); }
  function run() {
    var n = parseInt(nIn.value, 10) || 1, rate = parseFloat(rIn.value) || 0;
    var day = gpd * n, year = day * 365, cost = year / 1000 * rate;
    out('n', n); out('day', fmt(day)); out('year', fmt(year)); out('cost', fmt(cost));
    out('dev', (price * n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    out('n2', n === 1 ? '1 toilet' : n + ' toilets');
  }
  nIn.addEventListener('input', run); rIn.addEventListener('input', run); run();
});

// Count-up for big stats
(function () {
  var els = document.querySelectorAll('[data-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, raw = el.getAttribute('data-count'), target = parseFloat(raw);
      io.unobserve(el);
      if (isNaN(target) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var orig = el.textContent, start = null, dur = 1400;
      function step(t) { if (!start) start = t; var p = Math.min((t - start) / dur, 1), v = target * (1 - Math.pow(1 - p, 3));
        el.textContent = p < 1 ? Math.round(v).toLocaleString('en-US') : orig; if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }, { threshold: .4 });
  els.forEach(function (el) { io.observe(el); });
})();

// Product carousel arrows
document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
  var sec = track.closest('section'); if (!sec) return;
  var prev = sec.querySelector('[data-carousel-prev]'), next = sec.querySelector('[data-carousel-next]');
  if (!prev || !next) return;
  function step() { var li = track.querySelector('li'); return li ? li.getBoundingClientRect().width + 22 : track.clientWidth; }
  function update() {
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max;
    var hide = track.scrollWidth <= track.clientWidth + 2; prev.hidden = hide; next.hidden = hide;
  }
  prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); requestAnimationFrame(update);
});
